export enum PricingType {
  DEFAULT = 'DEFAULT',
  USAGE = 'USAGE',
}
